<template>
  <span>{{ $t('route.page401') }}</span>
</template>

<script>
export default {
  name: 'Page401'
}
</script>
